/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import { ComponentLinkProxy as ComponentLink } from 'src/components/component-link';

export const Filter = styled.div({
  marginBottom: token('space.100'),
  paddingLeft: token('space.100'),
  paddingRight: token('space.100'),
});

export const RefLink = styled(ComponentLink)({
  padding: `${token('space.075')} 0`,
  lineHeight: 'initial',
});

export const RefSelectorPanel = styled.div(
  {
    width: '352px',
  },
  media.upToSmall(`
    width: 300px;
  `)
);

export const InlineDialogWrapper = styled.div({
  '& > div': {
    padding: `${token('space.200')} ${token('space.200')} 0`,
  },
});

export const PopupContentWrapper = styled.div({
  padding: `${token('space.200')} ${token('space.200')} 0`,
});

// 380px is the width of the commit filter + the 'Full commit' nav button + right margins on the Source page;
export const RefSelectorWrapper = styled.div({
  maxWidth: 'fit-content',
  width: 'calc(100% - 380px)',
});
